var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitnessWeights(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18800_33028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73267 11.9718H16.2327",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23267 17.9718C6.83484 17.9718 6.45331 17.8137 6.17201 17.5324C5.8907 17.2511 5.73267 16.8696 5.73267 16.4718V7.47177C5.73267 7.07395 5.8907 6.69242 6.17201 6.41111C6.45331 6.12981 6.83484 5.97177 7.23267 5.97177C7.63049 5.97177 8.01202 6.12981 8.29333 6.41111C8.57463 6.69242 8.73267 7.07395 8.73267 7.47177V16.4718C8.73267 16.8696 8.57463 17.2511 8.29333 17.5324C8.01202 17.8137 7.63049 17.9718 7.23267 17.9718Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73267 11.9718H1.23267",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.23267 8.97177C3.83484 8.97177 3.45331 9.12981 3.17201 9.41111C2.8907 9.69242 2.73267 10.0739 2.73267 10.4718V13.4718C2.73267 13.8696 2.8907 14.2511 3.17201 14.5324C3.45331 14.8137 3.83484 14.9718 4.23267 14.9718C4.63049 14.9718 5.01202 14.8137 5.29333 14.5324C5.57463 14.2511 5.73267 13.8696 5.73267 13.4718V10.4718C5.73267 10.0739 5.57463 9.69242 5.29333 9.41111C5.01202 9.12981 4.63049 8.97177 4.23267 8.97177Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7327 17.9718C18.1305 17.9718 18.512 17.8137 18.7933 17.5324C19.0746 17.2511 19.2327 16.8696 19.2327 16.4718V7.47177C19.2327 7.07395 19.0746 6.69242 18.7933 6.41111C18.512 6.12981 18.1305 5.97177 17.7327 5.97177C17.3348 5.97177 16.9533 6.12981 16.672 6.41111C16.3907 6.69242 16.2327 7.07395 16.2327 7.47177V16.4718C16.2327 16.8696 16.3907 17.2511 16.672 17.5324C16.9533 17.8137 17.3348 17.9718 17.7327 17.9718Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2327 11.9718H23.7327",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7327 8.97177C21.1305 8.97177 21.512 9.12981 21.7933 9.41111C22.0746 9.69242 22.2327 10.0739 22.2327 10.4718V13.4718C22.2327 13.8696 22.0746 14.2511 21.7933 14.5324C21.512 14.8137 21.1305 14.9718 20.7327 14.9718C20.3348 14.9718 19.9533 14.8137 19.672 14.5324C19.3907 14.2511 19.2327 13.8696 19.2327 13.4718V10.4718C19.2327 10.0739 19.3907 9.69242 19.672 9.41111C19.9533 9.12981 20.3348 8.97177 20.7327 8.97177Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.31306,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18800_33028"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.482666 0.47168)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessWeights);
export default __webpack_public_path__ + "static/media/fitness-weights.205a6c2eb635b8118470d81c0de15673.svg";
export { ForwardRef as ReactComponent };